import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import CartHeader from "containers/CartOverview/CartHeader/CartHeader";
import CartProducts from "containers/CartOverview/CartProducts/CartProducts";
import CartFooter from "containers/CartOverview/CartFooter/CartFooter";
import useCart from "hooks/useCart";
import withToasts from "hoc/withToasts";
import {
  createCartUniqueId,
  resetCartUnqiueId,
} from "store/actions/order.action";
import "containers/CartOverview/CartOverview.css";

function CartOverview() {
  const componentTexts = window.appTexts.cart_page;
  const { currentCartItems } = useCart();
  const dispatch = useDispatch();

  //Handles cart unique id.
  useEffect(() => {
    if (currentCartItems.length > 0) {
      dispatch(createCartUniqueId());
    }

    return function () {
      if (currentCartItems.length === 0) {
        dispatch(resetCartUnqiueId());
      }
    };
  }, []);

  return (
    <React.Fragment>
      <CartHeader componentTexts={componentTexts} />
      <section className="cart-page">
        <CartProducts />
        <CartFooter componentTexts={componentTexts} />
      </section>
    </React.Fragment>
  );
}

export default withToasts(CartOverview);
